// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__4DqfT"};